import * as Yup from 'yup';
import BaseProductSchema from './BaseProductSchema';

/**
 * Validation schema for Add-on products
 * @param purchasedQuantity Number of items already purchased (for editing)
 */
const createAddonProductSchema = (purchasedQuantity = 0) => {
  const schema = Yup.object().shape({
    type: Yup.string()
      .required('Required field')
      .oneOf(['addon'], 'Must be an addon type'),
    ...BaseProductSchema,
    maxQuantity: Yup.mixed()
      .transform((value) => {
        if (value === '' || value === undefined || value === null) {
          return undefined;
        }
        const num = Number(value);
        return isNaN(num) ? undefined : num;
      })
      .optional()
      .test(
        'min-value',
        'You cannot decrease the number of available items to less than the number of items already sold.',
        function (value) {
          const { purchases } = this.parent;
          // Use purchases from FormValueDTO with fallback to purchasedQuantity parameter
          const soldItems = purchases || purchasedQuantity;
          // Allow 0 (unlimited) or any value >= soldItems
          return value === undefined || value === 0 || value >= soldItems;
        }
      )
      .test(
        'max-value',
        'Value must not exceed 999999',
        (value) => value === undefined || value <= 999999
      )
      .label('Available Items'),
    purchaseRequirements: Yup.object()
      .shape({
        requiresApproval: Yup.boolean(),
        questions: Yup.array(
          Yup.object().shape({
            question: Yup.string()
          })
        ),
        requiredOrganizationIds: Yup.array(Yup.string()),
        requiredAssociationIds: Yup.array(Yup.string())
      })
      .required('Required field')
  });

  return schema;
};

export default createAddonProductSchema;
